// resolveNodeIcon.js

const DEFAULT_ICON_KEY = 'deployed_code';

/**
 * Resolves icon props from a node type definition (no per-node override).
 *
 * @param {object|null} typeDef - Node type definition.
 * @returns {{ iconKey: string, iconPath: string, iconResource: string|null }}
 */
export function getTypeIconProps(typeDef) {
  const iconKey = typeof typeDef?.iconKey === 'string' ? typeDef.iconKey.trim() : '';

  return {
    iconKey: iconKey || DEFAULT_ICON_KEY,
    iconPath: '',
    iconResource: null,
  };
}

/**
 * Resolves the display icon for a node, preferring a per-record override when set.
 *
 * @param {object|null} node - Node document.
 * @param {object|null} typeDef - Node type definition for the node's type.
 * @returns {{
 *   iconKey: string,
 *   iconPath: string,
 *   iconResource: string|null,
 *   hasNodeOverride: boolean,
 * }}
 */
export function resolveNodeIcon({ node, typeDef } = {}) {
  const nodeIconKey = typeof node?.iconKey === 'string' ? node.iconKey.trim() : '';

  if (nodeIconKey) {
    return {
      iconKey: nodeIconKey,
      iconPath: '',
      iconResource: null,
      hasNodeOverride: true,
    };
  }

  const typeProps = getTypeIconProps(typeDef);

  return {
    ...typeProps,
    hasNodeOverride: false,
  };
}

/**
 * Resolves the collection header mark for Database.jsx.
 *
 * @returns {null}
 */
export function resolveCollectionHeaderIconResource() {
  return null;
}
